export default __webpack_public_path__ + "static/media/masai_refresh2.06371942.png";